// extracted by mini-css-extract-plugin
export var cancelButton = "_qx-5";
export var content = "_qx-3";
export var createButton = "_qx-6";
export var drawerContainer = "_qx-0";
export var footer = "_qx-2";
export var header = "_qx-1";
export var orderFormColumn = "_qx-4";